import ArrowBackButton from "../../../../components/button/ArrowBackButton"
import { useEffect, useState } from "react"
import useRoleForm from "./useRoleForm"
import { useParams } from "react-router-dom"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const RoleForm = () => {
    const params = useParams()
    const [isUpdate, setUpdate] = useState(false)
    const {
        payload,
        onChangeHandler,
        postRoleForm,
        putRoleForm,
        isSaving,
        getRoleForm
    } =  useRoleForm()

    useEffect(() => {
        if (params.role_id) {
            setUpdate(true)
            getRoleForm(params.role_id)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.role_id])
    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton title={isUpdate ? "Update Role" : "Create Role"} isTwoSection={true}/>
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    Role Information
                </h5>

                <form onSubmit={(e) => {
                    isUpdate ? putRoleForm(e): postRoleForm(e)
                }}>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="mb-4">
                            <label htmlFor="RoleId" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Role <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="Name"
                                className="form-control" 
                                id="Name" 
                                placeholder="Enter Role Name" 
                                value={payload.Name}
                                onChange={onChangeHandler}
                                style={{
                                    borderRadius: '8px',
                                    padding: '10px 12px',
                                    fontSize: '16px',
                                    border: '1px solid #d1d5db'
                                }}
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="RoleName" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Description <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                type="text" 
                                name="Description"
                                className="form-control" 
                                id="Description" 
                                placeholder="Enter Role Description" 
                                value={payload.Description}
                                onChange={onChangeHandler}
                                style={{
                                    borderRadius: '8px',
                                    padding: '10px 12px',
                                    fontSize: '16px',
                                    border: '1px solid #d1d5db'
                                }}
                            />
                        </div>
                    </div>
                    
                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Role"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default RoleForm